<div class="title" mat-dialog-title>Add Username & Password</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">You will need to contact your Vistar Account Manager to obtain the details below</div>
        <form [formGroup]="connectionForm">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Vistar Email</mat-label>
                <input matInput placeholder="Enter Vistar Email" formControlName="username" data-cy="vistar-email-input">
                <mat-error
                    *ngIf="connectionForm.get('username').errors && (connectionForm.get('username').touched || connectionForm.get('username').dirty)">
                    Invalid Email</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Vistar Password</mat-label>
                <input type="password" matInput placeholder="Enter Vistar Password" formControlName="password" data-cy="vistar-password-input">
                <mat-error
                    *ngIf="connectionForm.get('password').errors && (connectionForm.get('password').touched || connectionForm.get('password').dirty)">
                    Invalid Password</mat-error>
            </mat-form-field>
        </form>
    </div>
</div>
<div class="dialog-footer">
    <div>
        <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()" data-cy="vistar-dialog-connect-btn">
            Connect Data Source
        </button>
    </div>
</div>